import ActionBtn from '@/components/ActionBtn'
import ScalationTextFields from './ScalationTextFields'

const ScalationDataRow = ({ scalation, formHandler, isLoading, removeScalation, updateScalation }) => {


  return (
    <div className="col-lg-6 mb-2">
      <div className="technology-item-card ">
        <div className="technology-item-card-content">

          <ActionBtn
            icon="mdi:delete"
            className="remove-tech-btn pointer"
            onApply={() => removeScalation(scalation.id)} />

          <div className="row">
            <div className="col-12">
              <ScalationTextFields scalation={scalation} formHandler={formHandler} isLoading={isLoading} updateScalation={updateScalation} />
            </div>

          </div>
        </div>
      </div>
    </div>
  )
}

export default ScalationDataRow